import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { projects } from "../../data/resume";

// Projects are listed once, in src/data/resume.js, and rendered from there -
// so a project added for the resume also shows up here, and vice versa.
// Images are resolved by filename from src/Assets/Projects/. A project added
// from the site without an image stays off this page until one is committed;
// it can still appear on the resume.
function imageFor(fileName) {
  try {
    return require(`../../Assets/Projects/${fileName}`);
  } catch (error) {
    return undefined;
  }
}

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.filter((project) => project.image).map((project) => (
            <Col md={4} className="project-card" key={project.title}>
              <ProjectCard
                imgPath={imageFor(project.image)}
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.link}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
